import { countryIsUsOrCa } from "@flip/App/Store/Selectors/GeneralSelectors";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import { chain, ValidateCity, ValidateState } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import { AddressFieldDisplayModel } from "@insite/client-framework/Types/ApiModels";

const isEmpty = (value: string) => value.trim().length <= 0;
const getRequiredErrorMessage = (addressFieldDisplayCollection: AddressFieldDisplayModel) =>
    siteMessage("Field_Required", addressFieldDisplayCollection.displayName);

export const xValidateState: typeof ValidateState = props => {
    const { country, state } = props.parameter.address;
    const { addressFieldDisplayCollection } = props.parameter;
    const countries = getCurrentCountries(props.getState());
    if (!countries) {
        throw new Error("Cannot validate country. The website countries have not been loaded yet.");
    }

    if (!country) {
        // This is fine to simply return because the address country
        // is validated in the previous handler. If the country has not
        // been selected yet, it doesn"t make sense to show an error for the state.
        return;
    }

    const countryLookup = countries.find(c => c.id === country.id);

    if (
        countries.length > 0 &&
        countryLookup?.states &&
        countryLookup.states.length > 0 &&
        !state &&
        addressFieldDisplayCollection.state &&
        // XNG-Changes: FLIP-635
        countryIsUsOrCa(countryLookup?.abbreviation)
    ) {
        props.addressErrors.state = getRequiredErrorMessage(addressFieldDisplayCollection.state);
    }
};

export const xValidateCity: typeof ValidateCity = props => {
    const { validationRules, addressFieldDisplayCollection } = props.parameter;
    const { city, country } = props.parameter.address;
    // XNG-Changes: FLIP-635
    const isRequired = countryIsUsOrCa(country?.abbreviation) ? validationRules.city!.isRequired : false;

    if (addressFieldDisplayCollection.city?.isVisible && isRequired && isEmpty(city)) {
        props.addressErrors.city = getRequiredErrorMessage(addressFieldDisplayCollection.city);
    }
};

replaceInChain(chain, ValidateState, xValidateState);
replaceInChain(chain, ValidateCity, xValidateCity);
